var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99984 4.20866C9.34502 4.20866 9.62484 4.48848 9.62484 4.83366V9.83366C9.62484 10.1788 9.34502 10.4587 8.99984 10.4587C8.65466 10.4587 8.37484 10.1788 8.37484 9.83366V4.83366C8.37484 4.48848 8.65466 4.20866 8.99984 4.20866Z",
    fill: "#FF4136"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42627 12.7015C9.68284 12.9324 9.70364 13.3276 9.47273 13.5842L9.4644 13.5934C9.23348 13.85 8.8383 13.8708 8.58173 13.6399C8.32517 13.409 8.30437 13.0138 8.53528 12.7572L8.54361 12.748C8.77452 12.4914 9.16971 12.4706 9.42627 12.7015Z",
    fill: "#FF4136"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99984 1.29199C4.74264 1.29199 1.2915 4.74313 1.2915 9.00033C1.2915 13.2575 4.74264 16.7087 8.99984 16.7087C13.257 16.7087 16.7082 13.2575 16.7082 9.00033C16.7082 4.74313 13.257 1.29199 8.99984 1.29199ZM0.0415039 9.00033C0.0415039 4.05277 4.05229 0.0419922 8.99984 0.0419922C13.9474 0.0419922 17.9582 4.05277 17.9582 9.00033C17.9582 13.9479 13.9474 17.9587 8.99984 17.9587C4.05229 17.9587 0.0415039 13.9479 0.0415039 9.00033Z",
    fill: "#FF4136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.87b9a1212d4737d1b37c2689a06560df.svg";
export { ForwardRef as ReactComponent };